<template>
  <Transition name="modal">
    <div v-if="visible" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header px-3 py-2">
            <h5 class="text-white mb-0">Create new job</h5>
            <bryntum-button
              icon="b-fa-times"
              color="b-white"
              cls="b-white modal-close-btn"
              @click="$emit('close')"
            />
          </div>
          <div class="modal-body scrollbar scrollable-div">
            <div
              class="card border-0 pt-3 pb-1 px-3 mb-3 rounded-0 custom-shadow"
            >
              <div class="row filters">
                <div class="col-md-4 mb-3">
                  <span class="field-label">Client</span>
                  <v-select
                    v-model="selectedClient"
                    :options="clients"
                    code="id"
                    label="displayName"
                    :reduce="(c) => c.id"
                    :clearable="false"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <span class="field-label">Locations</span>
                  <v-select
                    v-model="selectedLocation"
                    :options="locationList"
                    code="id"
                    label="displayName"
                    :disabled="!selectedClient"
                    :clearable="false"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <span class="field-label">Job / Project Type</span>
                  <v-select
                    v-model="selectedProjectType"
                    :options="projectTypeList"
                    code="id"
                    label="displayName"
                    :clearable="false"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <span class="field-label">Primary Contact Name</span>
                  <input
                    class="form-control"
                    type="text"
                    v-model="contactName"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <span class="field-label">Primary Contact Phone</span>
                  <input
                    class="form-control"
                    type="text"
                    v-model="contactPhone"
                  />
                </div>
                <div class="col-md-4 mb-3">
                  <span class="field-label">Status / Priority</span>
                  <v-select
                    v-model="selectedStatus"
                    :options="statusList"
                    code="id"
                    label="displayName"
                    :clearable="false"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <span class="field-label">Start Date</span>
                  <DatePicker
                    class="datepicker mt-1"
                    style="width: 100% !important"
                    v-model="startDate"
                    :enable-time-picker="true"
                    format="dd-MMM-yyyy hh:mm a"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <span class="field-label">End Date</span>
                  <DatePicker
                    class="datepicker mt-1"
                    style="width: 100% !important"
                    v-model="endDate"
                    :enable-time-picker="true"
                    format="dd-MMM-yyyy hh:mm a"
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <span class="field-label">Description</span>
                  <textarea
                    v-model="eventName"
                    class="form-control"
                    cols="30"
                    rows="8"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-start p-3">
            <bryntum-button
              icon="b-fa-search"
              :text="saving ? 'Saving...' : 'Save'"
              color="b-purple"
              cls="b-raised"
              :disabled="saving"
              @click="saveEvent"
            />
            <bryntum-button
              icon="b-fa-times"
              text="Cancel"
              color="b-red"
              cls="b-raised"
              @click="$emit('close')"
            />
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { BryntumButton } from "@bryntum/scheduler-vue-3";
import DatePicker from "@/components/widgets/DatePicker";
import { useRoute } from "vue-router";
import { GlobalService } from "@/services/GlobalService";
import { formatStartEndDate, formatUTCdate } from "@/lib/helpers";
import MODULE from "@/lib/module";
export default {
  emits: ["close", "save"],
  props: {
    visible: Boolean,
    eventRecord: Object,
    resource: Object,
    saving: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BryntumButton,
    DatePicker,
  },
  setup(props, context) {
    const globalService = new GlobalService();
    const eventName = ref(null);
    const startDate = ref(null);
    const endDate = ref(null);
    const resourceId = ref(null);
    const contactName = ref(null);
    const contactPhone = ref(null);
    const selectedClient = ref(null);
    const selectedLocation = ref(null);
    const selectedProjectType = ref(null);
    const selectedStatus = ref(null);
    const clients = ref([]);
    const locationList = ref([]);
    const projectTypeList = ref([]);
    const statusList = ref([]);
    const route = useRoute();
    watch(
      () => props.visible,
      (value) => {
        if (value) {
          eventName.value = props.eventRecord.eventName;
          startDate.value = formatStartEndDate(props.eventRecord.startDate);
          endDate.value = formatStartEndDate(props.eventRecord.endDate, "end");
          resourceId.value = props.eventRecord.resourceId;
        }
      }
    );

    watch(
      () => selectedClient.value,
      (value) => {
        if (value) {
          loadLocations(value);
          loadClientDetails(value);
        }
      }
    );

    const loadLocations = async (clientId) => {
      const params = {
        t: route.query.t,
        u: route.query.u,
        uid: 1,
        userid: 1,
        s: "Jupiter",
        actionId: MODULE.CLIENT.UX.LOCATION,
        cid: clientId,
      };
      locationList.value = await globalService.getUXDropdown(params);
      selectedLocation.value =
        locationList.value.length > 0 ? locationList.value[0] : null;
    };

    const loadClientDetails = async (clientId) => {
      const params = {
        t: route.query.t,
        u: route.query.u,
        uid: 1,
        userid: 1,
        s: "Jupiter",
        clientID: clientId,
      };
      const client = await globalService.getClientDetails(params);
      if (client) {
        contactName.value = client.primaryContact;
        contactPhone.value = client.phone;
      }
    };

    onMounted(async () => {
      await loadDropdowns();
    });

    const loadDropdowns = async () => {
      const params = {
        t: route.query.t,
        u: route.query.u,
        uid: 1,
        userid: 1,
        s: "Jupiter",
      };

      clients.value = await globalService.getUXDropdown({
        ...params,
        actionId: MODULE.CLIENT.ACTION_ID,
      });

      projectTypeList.value = await globalService.getUXDropdown({
        ...params,
        actionId: MODULE.PROJECTS.UX.TYPE,
      });

      statusList.value = await globalService.getUXDropdown({
        ...params,
        actionId: MODULE.PROJECTS.UX.STATUS,
      });
    };

    const saveEvent = () => {
      context.emit("save", {
        name: eventName.value,
        startDate: formatUTCdate(startDate.value),
        endDate: formatUTCdate(endDate.value),
        resource: props.resource,
        client: selectedClient.value,
        location: selectedLocation.value,
        projectType: selectedProjectType.value,
        projectStatus: selectedStatus.value,
        contactName: contactName.value,
        contactPhone: contactPhone.value,
      });
    };
    return {
      eventName,
      startDate,
      endDate,
      resourceId,
      saveEvent,
      selectedClient,
      clients,
      selectedLocation,
      locationList,
      selectedProjectType,
      projectTypeList,
      selectedStatus,
      statusList,
      contactName,
      contactPhone,
    };
  },
};
</script>
